export default __webpack_public_path__ + "static/media/uploader-dexcom-problem-2.4c92c203.png";